// extracted by mini-css-extract-plugin
module.exports = {"productList":"SearchResult_productList__zcsx2","titleTips":"SearchResult_titleTips__diMVf"};